// import React from 'react';
// import { Select as SelectAntd, SelectProps } from 'antd';
import { Grid } from 'antd';

export interface TabOptions {
  values: Array<string>;
  selectedIndex: number;
  onTabPress: (val: number) => void;
}
function Tab({ values, selectedIndex, onTabPress }: TabOptions) {
  const { useBreakpoint } = Grid;
  const { lg } = useBreakpoint();
  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      {values?.map((item, index) => {
        return (
          <div
            key={item}
            style={{
              fontSize: lg ? '26px' : '15px',
              fontFamily: 'Roboto400',
              width: '100%',
              cursor: 'pointer',
              paddingTop: '9px',
              paddingBottom: '9px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: selectedIndex === index ? '#000' : '#6F7072',
              borderBottom: selectedIndex === index ? '2px solid #C21A17' : 'none',
              backgroundColor: '#fff',
              borderRight: index === 0 && selectedIndex == 0 ? '#B1B2B4' : 'none',
              borderLeft: index === 1 && selectedIndex == 1 ? '#B1B2B4' : 'none',
            }}
            onClick={() => onTabPress(index)}
          >
            {item}
          </div>
        );
      })}
    </div>
  );
}

export default Tab;
